/**
 * Joins conditional className fragments, skipping falsy values.
 * Small local equivalent of `clsx` - not worth adding the dependency for.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
